import {Dispatcher} from 'flux';

const disp = new Dispatcher();

export default disp;